var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9503 10.3828C12.4641 10.3828 12.0884 10.7657 12.0884 11.2612V13.2432H1.74586V1.75676H12.0884V3.73878C12.0884 4.23427 12.4641 4.61716 12.9503 4.61716C13.4365 4.61716 13.8122 4.23429 13.8122 3.73878V0.878378C13.8122 0.382883 13.4365 0 12.9503 0H0.861881C0.375692 0 0 0.382863 0 0.878378V14.1216C0 14.6171 0.375672 15 0.861881 15H12.9503C13.4365 15 13.8122 14.6171 13.8122 14.1216V11.2612C13.8122 10.7657 13.4145 10.3828 12.9503 10.3828Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7515 6.89188L17.1271 3.22083C16.7957 2.88305 16.2432 2.88305 15.9116 3.22083C15.5802 3.5586 15.5802 4.12165 15.9116 4.45961L18.0333 6.62185H9.87854C9.39236 6.62185 9.01666 7.00471 9.01666 7.50023C9.01666 7.99572 9.39234 8.37861 9.87854 8.37861H18.0775L15.9338 10.5633C15.757 10.7435 15.6907 10.9686 15.6907 11.1939C15.6907 11.4192 15.779 11.6443 15.9338 11.8246C16.2652 12.1623 16.8177 12.1623 17.1493 11.8246L20.7516 8.15334C21.0829 7.79294 21.0829 7.22988 20.7514 6.89196L20.7515 6.89188Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.ec12df6baaf24cb9a1f9ffb963471ecc.svg";
export { ForwardRef as ReactComponent };